module.exports = __webpack_public_path__ + "142c26d11ea5958d1b9cd0c676bb738a.jpg";